import request from "@/utils/request"

export function saveFacialOrderDetail(params) {
    return request({
        url: '/facial/order/save',
        method: 'post',
        data: params,
    })
}

export function queryFacialCashierOrder(params) {
    return request({
        url: '/facial/query/order/cashier',
        method: 'post',
        data: params,
    })
}

export function queryFacialOrderDetail(params) {
    return request({
        url: '/facial/query/order/detail',
        method: 'post',
        data: params,
    })
}

export function removeFacialOrderDetail(params) {
    return request({
        url: '/facial/order/remove',
        method: 'post',
        data: params,
    })
}

export function saveCashierFacialOrder(params) {
    return request({
        url: '/facial/save/order/cashier',
        method: 'post',
        data: params,
    })
}

export function cancelFacialCashier(params) {
    return request({
        url: '/facial/cancel/order/cashier',
        method: 'post',
        data: params,
    })
}

export function facialWriteOff(params) {
    return request({
        url: '/facial/order/writeOff',
        method: 'post',
        data: params,
    })
}
